module.exports = __webpack_public_path__ + "img/grey_005.9a909d87.png";